import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../services/api';
import toast from '../utils/toast';
import { ArrowLeftIcon, XMarkIcon } from '@heroicons/react/24/outline';
import FormSubmission from './FormSubmission';

const FormFilling = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState(null);

  useEffect(() => {
    fetchForm();
  }, []);

  const fetchForm = async () => {
    try {
      setLoading(true);
      const response = await api.get(`/forms/public/${slug}/user`);
      const formWithProducts = response.data.data;
      setForm(formWithProducts);
    } catch (error) {
      console.error("Error fetching form:", error);
      toast.error(error.response?.data?.message || 'Failed to load form');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (submissionPayload) => {
    try {
      // Use the authenticated user endpoint instead of the public endpoint
      const response = await api.post(`/forms/public/${slug}/submit/user`, submissionPayload);

      // Handle response
      const responseData = response.data.data;
      let successMessage = '';

      if (responseData.type === 'task') {
        successMessage = 'Task created successfully!';
      } else {
        successMessage = 'Form submitted successfully!';
      }

      return {
        success: true,
        type: responseData.type,
        message: successMessage
      };
    } catch (error) {
      console.error('Submission error:', error);
      throw error;
    }
  };

  const handleCancel = () => {
    navigate('/new/forms');
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!form) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <XMarkIcon className="mx-auto h-12 w-12 text-red-500" />
          <h3 className="mt-2 text-sm font-medium text-gray-900">Form not found</h3>
          <p className="mt-1 text-sm text-gray-500">The requested form could not be found.</p>
          <button
            onClick={() => navigate('/new/forms')}
            className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            Back to Forms
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center mb-4">
            <button
              onClick={() => navigate('/new/forms')}
              className="mr-4 p-2 text-gray-400 hover:text-gray-600 transition-colors"
            >
              <ArrowLeftIcon className="h-5 w-5" />
            </button>
            <h1 className="text-2xl font-bold text-gray-900">{form.name}</h1>
          </div>
          {form.description && (
            <p className="text-gray-600">{form.description}</p>
          )}
        </div>

        <FormSubmission
          form={form}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          isPublic={false}
          apiCall={api}
          token={null}
        />
      </div>
    </div>
  );
};

export default FormFilling; 